
import { CouponType, LinkStatus, ProductTaxType, VendorDiscountType, ExpirationType, CouponApplicationType, BitType, CurrencyType } from "./Enums";

import { VendorModel, VendorStoreModel } from "./VendorModel";
import { CustomerModel } from './CustomerModel';
import { ShippingProviderModel } from "./ShippingModel";
import { IBenefitModel, IGiviExpress } from "./Interfaces";
import * as moment from 'moment';
import { CommunityModel, CommunityVendorModel } from "./CommunityModel";
import { PackageVendorModel } from "./PackageModel";
import { CurrencyInfo } from '../currency-info';

export class CouponModel implements IGiviExpress, IBenefitModel {

    public constructor(init?: Partial<Pick<CouponModel, keyof CouponModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (init.vendor) {
                init.vendor = new VendorModel(init.vendor);
            }
            if (init.community) {
                init.community = new CommunityModel(init.community);
            }
            if (init.stores && init.stores.length) {
                init.stores = init.stores.map((item: any) => new VendorStoreModel(item));
            }
            if (init.shippingProvider && typeof init.shippingProvider === 'object') {
                init.shippingProvider = new ShippingProviderModel(init.shippingProvider);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;

    shippingProviderId?: number;

    sku: string;
    name: string;
    description: string;

    url: string;
    thumbnailUrl: string;
    imageUrl: string;

    isAvailable = true;

    // Precio proveedor
    vendorPrice = 0; // Sin IVA
    vendorPriceWithTax = 0;  // vendorPriceWithDiscount * 1.13

    // Precio a Givi
    vendorDiscountType = VendorDiscountType.Custom;
    vendorPriceWithDiscount = 0; // vendorPrice / 1.15

    // Precio de venta
    price = 0;
    // Precio de venta SALE
    allowDiscount = false;
    discountPercent = 0;
    priceWithDiscount = 0;
    customerCommissionPercent: number = 0;
    vendorCommissionPercent: number = 0;


    points = 0;

    productId: number;

    isForGift = false;
    isForOwner = false;

    taxType = ProductTaxType.Exempt;
    taxPercent = 0;

    quantity = 1;

    isActive = true;
    isVisible = true;

    isLite = true;

    expirationDays: number; // optional
    expirationAt?: Date;
    assignExpirationAt: Date;
    approvedAt: Date;

    //show the crono 
    timeToExpire: moment.Moment;
    expiredTimeText: string = "";

    isClaimed: boolean = false;

    createdAt = new Date;
    updatedAt?: Date;
    deletedAt?: Date;

    quantityNewLinks: number;

    maxQuantity: number;

    type: CouponType;

    bitType: BitType;

    expirationType: ExpirationType;

    quantityAccepted: number;

    linksCreated: number = 0;

    showInApp = false;

    applicationType = CouponApplicationType.General;

    vendor: VendorModel;
    communityVendor: CommunityVendorModel;
    packageVendor: PackageVendorModel;

    shippingProvider?: ShippingProviderModel;

    stores: VendorStoreModel[] = [];

    communityId?: number;
    community: CommunityModel;

    terms: string; // Use IBenefitModel

    // For purchase modal
    quantitySelected = 1;

    get currencySymbol(): string {

        return CurrencyInfo.symbol(this.vendor?.currencyType ?? CurrencyType.CRC);
    }

    get endDateAt(): Date {

        return this.expirationAt;
    }

    get linksAvailable(): number {

        var result = 0;

        result = this.maxQuantity - this.linksCreated;

        return result;
    }

    // Used to display in the form invoice
    get priceTotal(): number {

        let price = (this.allowDiscount && this.priceWithDiscount > 0) ? this.priceWithDiscount : this.price;
        // price = this.customerCommissionPercent > 0? (price * (this.customerCommissionPercent/100) + price): price; 
        return price * this.quantitySelected;
    }

    // Costo fijo del servicio en la moneda del comercio. Lo setea el componente con el
    // valor que devuelve el backend (GiviServiceCost): no se puede resolver acá porque
    // un modelo no consulta al API. Es el mismo número que el backend usa para cobrar.
    serviceCost = 0;

    get customerCommission(): number {

        return ((this.priceTotal) * (this.customerCommissionPercent / 100)) + this.serviceCost;
    }

}

export class CouponLinks {

    public constructor(init?: Partial<Pick<CouponLinks, keyof CouponLinks>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    createdAt = new Date;
    updatedAt?: Date;
    customers: CustomerModel;
    link: string;
    customerId: number;
    transactionId: number;
    name: string;
    lastName: string;
    email: string;
    phone: string;
    sentAt: Date;
    receivedAt: Date;
    deletedAt?: Date;
    status: LinkStatus;
    showCopiedLink: boolean = false;
}


export class ExplanatoryVideosModel {

    public constructor(init?: Partial<Pick<ExplanatoryVideosModel, keyof ExplanatoryVideosModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    urlImage: string;
    text: string;
    description: string;
    urlVideo: string;
    createdAt = new Date;
    updatedAt?: Date;
}

export class NotificationModel {

    public constructor(init?: Partial<Pick<NotificationModel, keyof NotificationModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    urlImage: string;
    title: string;
    description: string;
    text: string;
    createdAt = new Date;
    updatedAt?: Date;
}

export class MonthModel {
    id: number;
    name: string;
    year: number;
}
